import Header from './components/Header';
import MyTabs from './MyTabs';

function App() {
  return (
    <div className="App">
      <Header />
      <MyTabs />
    </div>
  );
}

export default App;
